import { render, staticRenderFns } from "./the-team.vue?vue&type=template&id=3724d20a&scoped=true&"
import script from "./the-team.vue?vue&type=script&lang=js&"
export * from "./the-team.vue?vue&type=script&lang=js&"
import style0 from "./the-team.vue?vue&type=style&index=0&id=3724d20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724d20a",
  null
  
)

export default component.exports